import 'normalize.css/normalize.css';
import 'vuetify/dist/vuetify.min.css';

import Vue from 'vue';
import VueKeyCloak from './vue-keycloak'; // this is from @dsb-norge/vue-keycloak-js
import axios from 'axios';
import VueAxios from 'vue-axios';

import vuetify from './plugins/vuetify';
import i18n from './locale'; // Internationalization

import App from './App.vue';
import router from './router';
import store from './store';

import './router/permission';
import config from './config';

import VCalendar from 'v-calendar';

import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.plugins.unregister(ChartDataLabels);

Vue.use(VueAxios, axios);

axios.interceptors.request.use((requestConfig) => {
  const auth = requestConfig.headers && requestConfig.headers.Authorization;
  if (typeof auth === 'string' && auth.length > 0 && !auth.startsWith('Bearer ')) {
    requestConfig.headers.Authorization = `Bearer ${auth}`;
  }
  return requestConfig;
});

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
  //...,                // ...other defaults
});



Vue.use(VueKeyCloak, {
  init: {
    onLoad: 'login-required',
    checkLoginIframe: false
  },
  config: {
    realm: config.VUE_APP_KEYCLOAK_REALM,
    url: config.VUE_APP_KEYCLOAK_URL,
    clientId: config.VUE_APP_KEYCLOAK_CLIENT_ID ?? 'apollo'
  },
  onReady: () => {

    // console.log("I am ready", arguments);
    new Vue({
      router,
      store,
      i18n,
      vuetify,
      render: (h) => h(App),
    }).$mount('#app');
  },
});

Vue.prototype.$formatAmount = function (amount) {
  return Number(amount).toFixed(2);
};

// new Vue({
//   router,
//   store,
//   i18n,
//   vuetify,
//   render: (h) => h(App),
// }).$mount('#app'); 
